export default "__VITE_PUBLIC_ASSET__e7f3e916__"